import { useState, useCallback } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface CageDetailsResponse {
  cage: string;
}

export const useCageDetails = (selectedHeaderToOrg?: string, pallet?: string, enabled: boolean = true) => {
  const [data, setData] = useState<CageDetailsResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async (toOrg?: string, palletVal?: string, cageVal?: string, callback?: (data: CageDetailsResponse[]) => void) => {
    if (!enabled || !toOrg || !palletVal) {
      setData([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { data: responseData } = await apiClient.get(
        API_CONFIG.ENDPOINTS.GET_CAGE_DETAILS,
        {
          params: {
            tosite: toOrg,
            palletval: palletVal,
            ...(cageVal && { cageval: cageVal })
          }
        }
      );
      console.log('Cage API Response:', responseData);
      
      if (responseData.success) {
        const cageData = responseData.data || [];
        setData(cageData);
        if (callback) {
          callback(cageData);
        }
      } else {
        throw new Error(responseData.error || 'Failed to fetch cage details');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
      console.error('Error fetching cage details:', err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  return {
    data,
    loading,
    error,
    refetch
  };
};